export interface MapState {
  id: string;
  bounds: google.maps.LatLngBoundsLiteral;
}

export class EmptyMapState implements MapState {
  id: string;
  bounds: google.maps.LatLngBoundsLiteral;

  constructor(id: string) {
    this.id = id;
    this.bounds = { east: -180, north: -1, south: 1, west: 180 };
  }
}
